import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Flex as FlexComponent } from '../../layout/flex'
import { Text as TextComponent } from '../../typography/text'
import { PB40T } from '../../colors'
import { SearchIcon } from '../../icons/search'

const Flex = styled(FlexComponent)`
  height: 300px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Text = styled(TextComponent)`
  margin: 16px 0 0 0;
`
const Circle = styled.div`
  width: 142px;
  height: 142px;
  border: 1px solid ${PB40T};
  border-radius: 71px;
  background-color: ${PB40T};
  display: flex;
  align-items: center;
  justify-content: center;
`
const defaultText = 'Enter a search query'
const SearchMode = ({ text = defaultText }) => {
  return (
    <Flex>
      <Circle>
        <SearchIcon size="large" />
      </Circle>
      <Text size="large">{text}</Text>
    </Flex>
  )
}

SearchMode.propTypes = {
  text: PropTypes.string
}

export { SearchMode, defaultText }
